import React, { useState, useEffect, useCallback } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { getTemplateString } from 'common/helpers/string';
import classNames from 'classnames/bind';
import PageLink from 'components/PageLink/PageLink';
import styles from './PaymentAmount.module.scss';
import debounce from 'lodash/debounce';
import { FormatMoney, parseStringAmountToFloat } from 'common/helpers/numberHelper';
import { useMediaQuery } from 'react-responsive'
import { isNullOrWhiteSpace } from 'common/helpers/string';
import { formProgression } from 'common/helpers/Gtm';

interface Props {
  PageData?: any;
  Model?: any;
  onChangeAmount: (amount: any) => void;
  LayoutModel?: any;
}

const PaymentAmount = ({
  PageData,
  Model,
  onChangeAmount,
  LayoutModel,
}: Props) => {
  const [amount, setAmount] = useState<any>();
  const [isEditedAmount, setIsEditedAmount] = useState<boolean>(false);
  const [IsCurrentBalanceVisible, setIsCurrentBalanceVisible] = useState(
    Model?.IsCurrentBalanceVisible,
  );
  const accountNumberTemplate = getTemplateString(PageData?.AccountNumber);
  const surnameTemplate = getTemplateString(PageData?.Surname);
  const lenderNameTemplate = getTemplateString(PageData?.LenderName);

  let valueAmount = amount ||
    Model?.FormModel?.VerifyIdentityFormModel?.ExternalPaymentAmount ||
    Model?.FormModel?.PaymentAmountFormModel?.Amount || 0;

  let cleanUpRegex = /^[., 0-9€£zł]+$/g;
  const { control, handleSubmit } = useForm({
    defaultValues: {
      PaymentAmountFormModel: {
        Amount:
          (isNaN(valueAmount)) ? FormatMoney(
            parseStringAmountToFloat(valueAmount),
            Model?.FormattedCurrencySymbol,
            LayoutModel?.IsCurrencyOnTheLeftSide,
            LayoutModel?.DecimalSeparatorForNumberFormatter,
          ) :
            FormatMoney(
              parseFloat(valueAmount),
              Model?.FormattedCurrencySymbol,
              LayoutModel?.IsCurrencyOnTheLeftSide,
              LayoutModel?.DecimalSeparatorForNumberFormatter,
            )
      },
    },
  });

  const getCurrencyClass = () => {
    var currencyClass = 'Icon-euro--after';

    if (Model.Currency === 'PLN') {
      currencyClass = 'Icon-zt--after';
    } else if (Model.Currency === 'GBP') {
      currencyClass = 'Icon-ps--after';
    }
    return currencyClass;
  };

  const amountChange = useCallback(
    (e: any, callback: Function) => {
      callback(e.target.value);
      let match = e.target.value.match(cleanUpRegex);
      if (e.target.value !== null && match != null) {
        var parsedAmount = (isNaN(e.target.value)) ? FormatMoney(
          parseStringAmountToFloat(e.target.value),
          Model?.FormattedCurrencySymbol,
          LayoutModel?.IsCurrencyOnTheLeftSide,
          LayoutModel?.DecimalSeparatorForNumberFormatter,
        ) :
          FormatMoney(
            parseFloat(e.target.value),
            Model?.FormattedCurrencySymbol,
            LayoutModel?.IsCurrencyOnTheLeftSide,
            LayoutModel?.DecimalSeparatorForNumberFormatter,
          );
        let setCursorLimit = parseInt(parsedAmount);
        e.target.value = parsedAmount;
        e.target.setSelectionRange(setCursorLimit.toString().length, setCursorLimit.toString().length);
        if (parseStringAmountToFloat(e.target.value) == 0) {
          e.target.value = "";
        }
        setAmount(parsedAmount);
        setIsEditedAmount(true);
      }
    },
    [amount],
  );

  const onFocusOutPaymentAmount = async (e:any) => {

    var formName = Model?.IsUserAuthenticated ? 'Logged in Single Payment' : 'Logged out single payment';
    formProgression(e,formName,'PaymentAmount');

  }

  const handleClick = useCallback(
    (e: any) => {
      if (parseStringAmountToFloat(e.target.value) == 0) {
        e.target.value = "";
      }
    },
    [amount],
  );

  useEffect(() => {
    var paymentAmountFormModel = {
      PaymentAmountFormModel: {
        Amount:
          amount ||
          Model?.FormModel?.VerifyIdentityFormModel?.ExternalPaymentAmount ||
          Model?.FormModel?.PaymentAmountFormModel?.Amount ||
          '',
      },
    };
    if (amount !== null && typeof amount !== 'undefined' && amount !== '') {
      onChangeAmount(paymentAmountFormModel);
    }
  }, [amount]);

  useEffect(() => {
    if (Model?.FormModel?.VerifyIdentityFormModel?.ExternalPaymentAmount !== null && isEditedAmount === false) {
      setAmount(Model?.FormModel?.VerifyIdentityFormModel?.ExternalPaymentAmount);
    }
    if (Model?.FormModel?.PaymentAmountFormModel?.Amount !== null && isEditedAmount === false) {
      setAmount(Model?.FormModel?.PaymentAmountFormModel?.Amount);
    }
  }, [Model]);


  return (
    <div className={styles.wrapper}>
      <div className={styles.section}>
        <div className={styles.payment_wrapper}>
          <div className={styles.payment_container}>
            <div className={styles.Heading_paymentWrapper}>
              <h1 className={'Heading' + ' ' + styles.Heading__payment}>
                {PageData?.Header}
              </h1>
            </div>
            <div className={styles.payment_section}>
              <div className={styles.payment_detailwrapper}>
                <div
                  className={
                    styles.payment_detailsection + ' ' + styles.success
                  }
                >
                  <div className={styles.hortube}></div>
                  <div className={styles.content}>
                    {PageData?.VerifiedMessage}
                    <span className={styles.accountdetails}>
                      {accountNumberTemplate &&
                        accountNumberTemplate({
                          AccountNumber: Model?.DebtReference,
                        })}
                      {surnameTemplate &&
                        surnameTemplate({ Surname: Model?.SurName })}
                      {lenderNameTemplate &&
                        lenderNameTemplate({ LenderName: Model?.LenderName })}
                    </span>
                    {PageData?.SecurePaymentMessage}
                  </div>
                </div>
                {IsCurrentBalanceVisible === true && (
                  <div
                    className={
                      styles.payment_detailsection +
                      ' ' +
                      styles.current_balance
                    }
                  >
                    <div className={styles.hortube}></div>
                    <div className={styles.content}>
                      <span> {PageData?.CurrentBalanceLabel}</span>
                      <p
                        dangerouslySetInnerHTML={{
                          __html: Model?.FormattedCurrencyDebtBalance,
                        }}
                      />
                    </div>
                  </div>
                )}
                {Model?.hasOffer === true && (
                  <div
                    className={styles.payment_detailsection + ' ' + styles.wait}
                  >
                    <div className={styles.hortube}></div>
                    <div className={styles.content}>
                      <span>{PageData?.OfferAvailableLabel}</span>
                      {PageData?.RegisterOrLoginToViewOfferLabel}
                    </div>
                  </div>
                )}
              </div>
              {Model?.hasOffer === true && (
                <div className="u-center">
                  <PageLink url={Model?.LoginUrl} className={styles.login_btn}>
                    {PageData?.LoginToExploreOfferLabel}
                  </PageLink>
                  <div className={styles.operatorsymbol_section}>
                    {PageData?.ORLabel}
                  </div>
                </div>
              )}

              {!Model?.IsPayFullBalance && (
                <div className={styles.paymentselection_section}>
                  <div className={styles.paymentselection_content}>
                    <span className={styles.Caption}>
                      {PageData?.SelectPaymentAmountLabel}
                    </span>
                  </div>
                  <div className={styles.paymentselection_content}>
                    <Controller
                      control={control}
                      name={'PaymentAmountFormModel.Amount'}
                      render={({
                        field: { onChange, name, value },
                      }) => (
                        <input
                          name={name}
                          defaultValue={value}
                          className={classNames(
                            styles.amount_input,
                            (Model?.FormModel?.PaymentAmountFormModel
                              ?.AmountHasError || value.match(cleanUpRegex) == null)
                              ? styles.error_field
                              : styles.amount_input,
                          )}
                          onChange={
                            debounce(
                              (e: any) => amountChange(e, onChange),
                              1000,
                            )}
                          onClick={(e: any) => handleClick(e)}
                          onBlur = {(e)=>onFocusOutPaymentAmount(e)}
                        />
                      )}
                    />
                  </div>
                </div>
              )}
              {Model?.FormModel?.PaymentAmountFormModel?.AmountHasError &&
                typeof amount !== 'undefined' &&
                amount !== '' && (
                  <div
                    className={styles.error_message}
                    dangerouslySetInnerHTML={{
                      __html:
                        Model?.FormModel?.PaymentAmountFormModel
                          ?.AmountErrorMessage,
                    }}
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentAmount;
